export const environment = {
  production: true,
  apiBaseUrl: import.meta.env.NG_APP_APIBASE_URL,
  supabaseUrl: import.meta.env.NG_APP_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.NG_APP_SUPABASE_ANON_KEY,
  // resendKey: import.meta.env.NG_APP_RESEND_KEY,
  fbAppId: import.meta.env.NG_APP_FB_APP_ID,


};

